<template>
  <header-main
    v-if="!isWebView"
    :sticky-top="stickyTop"
    :narrow="narrow"
    :is-ultra="isUltra"
  />
  <div
    v-if="isUltra"
    class="flex-1"
  >
    <slot></slot>
  </div>
  <slot v-else />
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue';

export default {
  name: 'Banner',
  components: {
    HeaderMain,
  },
  props: {
    stickyTop: {
      type: Boolean,
      required: false,
      default: false,
    },
    narrow: {
      type: Boolean,
      required: false,
      default: false,
    },
    isUltra: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const isWebView =
      typeof window !== 'undefined' &&
      typeof window.ReactNativeWebView !== 'undefined';

    return { isWebView };
  },
};
</script>
